"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _services = require("@alycecom/services");

var _AuthLoading = _interopRequireDefault(require("./AuthLoading"));

var PrivateRoute = function PrivateRoute(_ref) {
  var _render = _ref.render,
      isAuthenticated = _ref.isAuthenticated,
      isAuthorized = _ref.isAuthorized,
      canAccessDashboard = _ref.canAccessDashboard,
      _ref$unauthorizedMess = _ref.unauthorizedMessage,
      unauthorizedMessage = _ref$unauthorizedMess === void 0 ? 'You don’t have access to that page' : _ref$unauthorizedMess,
      routeProps = (0, _objectWithoutProperties2.default)(_ref, ["render", "isAuthenticated", "isAuthorized", "canAccessDashboard", "unauthorizedMessage"]);

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, (0, _extends2.default)({}, routeProps, {
    render: function render(props) {
      if (!isAuthenticated) {
        return /*#__PURE__*/_react.default.createElement(_AuthLoading.default, null);
      }

      if (isAuthorized === false) {
        showGlobalMessage({
          type: _services.MessageType.Error,
          text: unauthorizedMessage
        });
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
          to: "/"
        });
      }

      if (canAccessDashboard === false) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
          to: "/access-denied"
        });
      }

      return _render(props);
    }
  }));
};

var _default = PrivateRoute;
exports.default = _default;